import { GET } from '@/shared/api/requests';

export interface DroneVideoInfo {
  id: number;
  uuid: string;
  date: string;
  index_url: string;
  gcs_folder_path: string;
  original_folder_name: string;
}

export interface DroneData {
  dates: string[];
  videos: DroneVideoInfo[];
}

export interface ProjectDrones {
  [droneType: string]: {
    [droneName: string]: DroneData;
  };
}

export interface DroneProject {
  id: number;
  name: string;
  alias: string;
}

export interface DronesResponse {
  project: DroneProject;
  drone_types: string[];
  project_drones: ProjectDrones;
}

/**
 * Get drone videos for a project from GCS (DroneVideo model)
 * This replaces the old FTP-based endpoint
 */
export const getDroneData = async (projectId: string): Promise<DronesResponse> => {
  const response = await GET(`/drones/project/${projectId}/`);
  return response.data;
}; 